export enum StatusTypeKey {
  SCADA = 'scada',
  HMI = 'hmi',
  ACTIVE = 'active',
}

export interface StatusType {
  key: StatusTypeKey;
  pointName: string;
  displayName: string;
  tooltipMessage: string;
  topic: string;
}

export interface TemplateStatusValues {
  scadaStatus: number | undefined;
  hmiStatus: number | undefined;
  activeStatus: number | undefined;
  statusTypes: StatusType[];
}

export type FormValues = {
  [fieldName: string]: string | number | boolean;
};
